if (!customElements.get("bis-trigger")) {
  class BisTrigger extends HTMLElement {
    constructor() {
      super();

      this.modalTrigger = this.querySelector(".custom-klaviyo-bis-trigger");
      this.modal = this.querySelector(".custom-klaviyo-bis-modal");
      this.close = this.querySelector(".custom-klaviyo-bis-close");

      this.action = this.querySelector(".modal-action");
      this.feedback = this.querySelector(".modal-feedback");

      this.formInput = this.querySelector(".custom-klaviyo-bis-form-input");
      this.formVariantId = this.querySelector("[name='bis_variant_id']");
      this.submit = this.querySelector(".custom-klaviyo-bis-submit");
    }

    handleClose = (e) => {
      this.modal.close();
    }

    handleOpenMoodal = (e) => {
      this.feedback.innerHTML = ``;
      if (this.action.classList.contains("hidden")) {
        this.action.classList.remove("hidden");
      }
      if (this.feedback.classList.contains("hidden")) {
      } else {
        this.feedback.classList.add("hidden");
      }
      this.modal.showModal();
    }

    handleSubmit = async (e) => {
      e.preventDefault();

      if (!this.formInput.value) {
        return
      }
      
      console.log("CLICK: ", this.formInput.value);
      console.log("ID: ", this.formVariantId.value);

      const options = {
        method: "POST",
        headers: {
          accept: "application/json",
          revision: "2024-06-15",
          "content-type": "application/json",
        },
        body: JSON.stringify({
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              channels: ["EMAIL"],
              profile: {
                data: {
                  type: "profile",
                  // id: "01GDDKASAP8TKDDA2GRZDSVP4H",
                  attributes: {
                    email: this.formInput.value,
                    // external_id: "63f64a2b-c6bf-40c7-b81f-bed08162edbe",
                  },
                },
              },
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: `$shopify:::$default:::${this.formVariantId.value}`,
                },
              },
            },
          },
        }),
      };

      fetch(
        "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=Y6puuk",
        options
      )
        .then((response) => {
          if (response.status === 202) {
            this.action.classList.add("hidden");
            this.feedback.classList.remove("hidden");
            this.feedback.innerHTML = `<p>La tua iscrizione è avvenuta con successo!</p>`;
          } else {
            this.action.classList.add("hidden");
            this.feedback.classList.remove("hidden");
            this.feedback.innerHTML = `<p>Purtroppo non ha funzionato. Controlla il tuo indirizzo email.</p>`;
          }
          console.log(response)
        })
        .catch((err) => console.error(err));
    };

    connectedCallback() {
      console.log("BIS TRIGGER CONNECTED");
      this.modalTrigger.addEventListener("click", this.handleOpenMoodal.bind(this));
      this.close.addEventListener("click", this.handleClose.bind(this));
      this.submit.addEventListener("click", this.handleSubmit.bind(this));
    }
  }

  customElements.define("bis-trigger", BisTrigger);
}

